// @ts-nocheck
import { uid } from 'quasar';
import { defineStore } from 'pinia';
import { i18n } from 'src/boot/i18n';
import { CONSTANTS } from 'src/constants';
import type { dynamicObj } from 'src/pages/assets';
import { getUserDetailFromkey } from 'src/utils/UserDetails';
import { documentDetailApiService, masterDataApiService } from 'src/services';
import {
  setWithExpiry,
  getCustomFieldStorageName,
} from 'src/utils/cacheHelper';
import {
  saveSortOrderToStorage,
  getSavedOrderByColumns,
} from 'src/utils/ms_utlis';
import {
  useFormBuilderStore,
  useDocumentStore,
  useLookupFunctionStore,
} from 'src/store/main';

export const useDocMasterDataLookUpStore = defineStore('doc_ms_data_lookup', {
  state: () => ({
    doc_store: useDocumentStore(),
    form_builder_store: useFormBuilderStore(),
    lookup_function_store: useLookupFunctionStore(),
    orderByMap: new Map() as Map<string, string>,
    trigger_search: false,
    selected_row: '',
    master_data_fields_map: new Map(),
    populate_row_to_view: false,
    model: [] as any,
    master_lookup_columns: {} as dynamicObj,
    column_ms_mapping: {} as dynamicObj,
    advance_filters: {} as dynamicObj,
    inital_filters: {} as dynamicObj,
    master_lookup_type: '',
    search_op_key_postfix: '_ms_search_operator',
    default_operator: 'smart',
    search_operators: [
      {
        label: i18n.t('smart'),
        value: 'smart',
      },
      {
        label: i18n.t('contains'),
        value: 'contains',
      },
      {
        value: 'ends_with',
        label: i18n.t('ends_with'),
      },
      {
        value: 'exact',
        label: i18n.t('exact'),
      },
      {
        value: 'starts_with',
        label: i18n.t('starts_with'),
      },
    ],
    date_search_operators: [
      {
        label: i18n.t('eq'),
        value: 'equal',
      },
      {
        label: i18n.t('before_date'),
        value: 'before',
      },
      {
        value: 'after',
        label: i18n.t('after_date'),
      },
    ],
    date_search_operators: [
      {
        label: i18n.t('eq'),
        value: 'equal',
      },
      {
        label: i18n.t('before_date'),
        value: 'before',
      },
      {
        value: 'after',
        label: i18n.t('after_date'),
      },
    ],
    changed_fields: [] as any,
    fields_with_autotrigger: [] as any,
    groups_to_update: [] as any,
    last_search_params: {} as dynamicObj,
    isDraggle: true,

    // newly added fields
    search_operator: '',
    fuzzyDialog: false,
    search_params: {} as dynamicObj,
    tableColumns: [] as dynamicObj[],
    match_all_filters: true,
    lookupDictionary: {} as any,
    autoTriggerFields: {} as any,
    alreadyExecutedGroups: [] as string[],

    lovFields: {} as dynamicObj,
    lovFieldsList: {} as dynamicObj,

    // for AI and extracted table
    autoTriggerTableFields: {} as any,
    alreadyExecutedTableGroups: [] as string[],
    lookupTableDictionary: {} as any,
    lookupTableConfigurations: new Map(),
  }),
  getters: {},
  actions: {
    resetMasterDataStore() {
      this.trigger_search = false;
      this.selected_row = '';
      this.master_data_fields_map = new Map();
      this.populate_row_to_view = false;
      this.advance_filters = {} as dynamicObj;
      this.model = [] as any;
      this.alreadyExecutedTableGroups = [];
    },

    setColumnsByType(type: string, columns: dynamicObj[]) {
      this.master_lookup_columns[type] = columns;
    },

    getColumnsByType(type: string) {
      if (this.master_lookup_columns.hasOwnProperty(type)) {
         
        return this.master_lookup_columns[type];
      }
      return [];
    },

    async fetchCustomLabels(doc_type: string) {
      try {
        const response = await documentDetailApiService.getCustomLabels({
          doc_type,
        });
        if (!response || Object.keys(response).length === 0) {
          return;
        }
        this.setCustomFieldLabels(response.data);
        setWithExpiry(getCustomFieldStorageName(doc_type), response.data);
      } catch (err) {
        logError(err);
      }
    },

    setCustomFieldLabels(custom_fields: dynamicObj) {
      for (const prop in custom_fields) {
        this.column_ms_mapping[prop] = prop;
        this.master_lookup_columns['supplier'].push(
          Object.assign(
            {},
            {
              name: prop,
              label: custom_fields[prop],
              field: prop,
              align: 'left',
            },
          ),
        );
      }
    },

    getOrderByColumns(type: string) {
      this.orderByMap = getSavedOrderByColumns(type);
    },

    saveOrderByColumns(type: string) {
      saveSortOrderToStorage(type, this.orderByMap);
    },

    isCurrentFieldPrimary(field_name: string) {
      for (const [index, filter_field] of Object.entries(this.inital_filters)) {
        const fieldDef = filter_field as dynamicObj;
        if (field_name === fieldDef.field_name && fieldDef.primary === true) {
          return true;
        }
      }

      return false;
    },

    isContentChanged(old_content: string, new_content: string) {
      if (old_content) {
        old_content = old_content.toString();
        old_content = old_content.replace(/\s/g, '').toLowerCase();
      }

      if (new_content) {
        new_content = new_content.toString();
        new_content = new_content.replace(/\s/g, '').toLowerCase();
      }

      if (new_content !== old_content) {
        return true;
      }

      return false;
    },
    prepareMSFilter(fieldModel: any, config: any, formBuilderModel: any) {
      const field_name = fieldModel.name;

      const id = uid();
      const existingFilter = this.checkExistingFilters(fieldModel.name);
      if (!existingFilter) {
        this.advance_filters[id] = {
          fuzzy_field: config.lookup_field.toLowerCase(),
          search_text: formBuilderModel[field_name].formatted_value,
          field_name,
          primary: true,
        };

        this.master_lookup_type = config.lookup_dataset_name;
        // this.ms_view_model = this.formBuilderConfigModel
        this.master_data_fields_map = new Map();
        this.master_data_fields_map.set(this.master_lookup_type, config);

        // primary fields
        if (config.parent_field_id && config.parent_field_id != '') {
          let parent_field = null;
          for (const [index, field] of config.fields.entries()) {
            if (
              config.parent_field_id == field.field_id &&
              !this.checkExistingFilters(field.field_name)
            ) {
              parent_field = field;
              break;
            }
          }

          if (parent_field) {
            const id = uid();
            this.advance_filters[id] = {
              fuzzy_field: parent_field.lookup_field.toLowerCase(),
              search_text:
                formBuilderModel[parent_field.field_name].formatted_value,
              field_name: parent_field.field_name,
              primary: false,
            };
          }
        }
      }
    },

    //To avoid adding duplicate filter for same fields
    checkExistingFilters(fieldName: any): any {
      return Object.values(this.advance_filters).find(
        (filter) => filter.field_name === fieldName,
      );
    },

    // ==================================Auto trigger==================================================================
    async loadAutoTriggerData(
      item: any,
      formatted_value = '',
      isTable = false,
    ) {
      const dict = isTable ? this.lookupTableDictionary : this.lookupDictionary;
      const configObj = dict[item.id];

      const alreadyExecutedGroups = isTable
        ? this.alreadyExecutedTableGroups
        : this.alreadyExecutedGroups;

      // make execution key unique for table rows as all groups will have same id
      const executionKey = isTable
        ? item.id + '_' + item.rowId
        : item.id;
      const value = isTable
        ? formatted_value
        : this.form_builder_store.formBuilderModel[item.fieldName]
            ?.formatted_value;
      if (alreadyExecutedGroups.includes(executionKey) || !value) {
        return { message: CONSTANTS.not_executed };
      }
      alreadyExecutedGroups.push(executionKey);
      const advance_filters = {} as dynamicObj;
      const id = uid();
      const form_data = {} as dynamicObj;
      const fieldObj = configObj['fields_obj'][item.fieldName];
      if (!fieldObj) {
        console.error(`Field object not found for ${item.fieldName}`);
        return { message: CONSTANTS.not_executed };
      }
      advance_filters[id] = {
        field: { field: fieldObj.lookup_field },
        operator: fieldObj.search_operator ?? 'contains',
        search_text: value,
      };
      return await this.lookup_function_store.searchByField(
        advance_filters,
        configObj.lookup_dataset_name,
        form_data,
      );
    },

    findDependentLookups(
      configuration: any,
      lookup_dataset_name: string,
      field_name: string,
    ): any[] {
      const result = [] as any;
      const visited = new Set<string>(); // To prevent infinite recursion

      function findDependencies(datasetName: string, fieldName: string): void {
        // Create a unique key for this dataset-field combination
        const key = `${datasetName}-${fieldName}`;
        if (visited.has(key)) {
          return; // Already processed this combination
        }
        visited.add(key);

        // Step 1: Find the configuration with matching lookup_dataset_name
        const targetConfig = configuration.find(
          (config: any) => config.lookup_dataset_name === datasetName,
        );

        if (!targetConfig) {
          return; // Configuration not found
        }

        // Step 2: Iterate through fields and find those NOT matching the given field_name
        const otherFields = targetConfig.fields.filter(
          (field: any) => field.field_name !== fieldName,
        );

        // Step 3: For each other field, check if it's auto_trigger in any other config
        otherFields.forEach((field: any) => {
          configuration.forEach((config: any) => {
            // Skip the current config we're analyzing
            if (config.lookup_dataset_name === datasetName || !config.fields) {
              return;
            }

            // Check if this field exists in other configs with auto_trigger = true
            const autoTriggerField = config.fields.find(
              (configField: any) =>
                configField.field_name === field.field_name &&
                configField.auto_trigger === true,
            );

            if (autoTriggerField) {
              // Step 4 & 5: Push to result array
              const dependency = {
                id: config.id,
                lookup_dataset_name: config.lookup_dataset_name,
                fieldName: field.field_name,
              };

              // Check if this dependency already exists in result
              const exists = result.some(
                (item: any) =>
                  item.id === dependency.id &&
                  item.fieldName === dependency.fieldName,
              );

              if (!exists) {
                result.push(dependency);

                // Recursive call to find dependencies of this dependency
                findDependencies(config.lookup_dataset_name, field.field_name);
              }
            }
          });
        });
      }

      // Start the process by finding dependencies of the initial configuration
      findDependencies(lookup_dataset_name, field_name);

      return result;
    },

    setupTableLookup(lookup_configurations: any) {
      try {
        this.lookupTableConfigurations = new Map();
        if (!lookup_configurations) {
          return;
        }

        this.autoTriggerTableFields = {};

        for (const [index, item] of lookup_configurations.entries()) {
          if (!item.hasOwnProperty('fields') || !Array.isArray(item.fields)) {
            continue;
          }

          const itemTempObj = JSON.parse(JSON.stringify(item));

          this.lookupTableDictionary[item.id] = itemTempObj;
          this.lookupTableDictionary[item.id]['fields_obj'] = {};
          this.lookupTableDictionary[item.id]['fields'] = [];

          for (const [index, field] of item.fields.entries()) {
            const fieldName = field.field_name ?? field.column_name;
            if (
              !this.lookupTableDictionary[item.id][
                'fields_obj'
              ][fieldName]
            ) {
              this.lookupTableDictionary[item.id][
                'fields_obj'
              ][fieldName] = {};
            }

            this.lookupTableDictionary[item.id]['fields_obj'][
              fieldName
            ] = field;
            this.lookupTableDictionary[item.id]['fields'].push(
              field,
            );

            if (field.auto_trigger) {
              if (!this.autoTriggerTableFields[fieldName]) {
                this.autoTriggerTableFields[fieldName] = [];
              }
              this.autoTriggerTableFields[fieldName].push(item);
            }

            if (!field.is_searchable) {
              continue;
            }

            this.lookupTableConfigurations.set(
              fieldName,
              Object.assign(JSON.parse(JSON.stringify(field)), {
                id: item.id,
                lookup_dataset_name: item.lookup_dataset_name,
                request_fields: item.request_fields,
                fields: JSON.parse(JSON.stringify(item.fields)),
              }),
            );
          }
        }
      } catch (e) {
        console.error('Error in setupTableLookup:', e);
      }
    },

    preapreAutoTriggerList(
      autoTriggerObject: any,
      fieldName: string,
      dataSetToSkip = '',
      triggerDataSet = true,
    ): any {
      const currectDataSet = [] as any;

      if (!autoTriggerObject || autoTriggerObject.length == 0) {
        return currectDataSet;
      }

      for (const config of autoTriggerObject) {
        if (config.lookup_dataset_name == dataSetToSkip) {
          continue;
        }
        currectDataSet.push({
          id: config.id,
          lookup_dataset_name: config.lookup_dataset_name,
          fieldName: fieldName,
          triggerDataSet: triggerDataSet,
        });
      }

      return currectDataSet;
    },
    removeDuplicateGroups(currectDataSet: any) {
      const seen = new Set();
      const uniqueByDatasetName = [];

      for (const item of currectDataSet) {
        if (!seen.has(item.id)) {
          seen.add(item.id);
          uniqueByDatasetName.push(item);
        }
      }

      return uniqueByDatasetName;
    },

    // ================================LOV=====================================

    async triggerlookupLovs(
      lovConfigurations: any,
      columName: string,
      triggerDefaultLovs: boolean,
      selectedValue: string,
      resetChild: boolean,
    ) {
      if (!lovConfigurations || Object.keys(lovConfigurations).length == 0) {
        return;
      }

      mainLoop: for (const config of lovConfigurations) {
        const configKey = config.column_name ?? config.field_name;

        if (!config.fields || config.fields.length == 0) {
          continue;
        }

        if (!this.lovFieldsList[configKey] && configKey) {
          this.lovFields[configKey] = config;
          this.lovFieldsList[configKey] = [];
        }

        for (const field of config.fields) {
          if (triggerDefaultLovs) {
            if (!field.field_name) {
              let filter = null;
              if (field.lookup_field) {
                let value = field.filter_value;
                if (value == 'current_user') {
                  value = getUserDetailFromkey('id');
                }
                filter = JSON.stringify({ [field.lookup_field]: value });
              }

              this.lovFieldsList[configKey] =
                await masterDataApiService.getLookupLov(config.id, filter);
            }
          } else if (columName == field.field_name) {
            const filter = { [field['lookup_field']]: selectedValue };
            const key = configKey + '_' + selectedValue;
            this.lovFieldsList[key] = await masterDataApiService.getLookupLov(
              config.id,
              JSON.stringify(filter),
            );

            // if (resetChild) {
            //   this.selectedRow[configKey] = '';
            // }

            break mainLoop;
          }
        }
      }
    },
  },
});
